'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.system = void 0;
var adapter_1 = require("../adapter");
var System = /** @class */ (function () {
    function System() {
    }
    System.prototype.ping = function () {
        return adapter_1.adapter.system.ping();
    };
    return System;
}());
exports.system = new System();
